"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeCityName = normalizeCityName;
function normalizeCityName(name) {
    if (!name || typeof name !== 'string')
        return '';
    return name
        .toLowerCase()
        .trim()
        .replace(/-/g, ' ')
        .replace(/\s+/g, ' ')
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '');
}
